import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';

@Component({
  selector: 'app-property-search-header',
  templateUrl: './property-search-header.component.html',
  styleUrls: ['./property-search-header.component.css']
})
export class PropertySearchHeaderComponent implements OnInit {
  recs: any;
  @Input() recordCount: number;
  towns: string[] = [];
  DocCategories2: string;

  //constructor(private router: Router, private store: Store<AppState>, public nav: NavMenuService) {
  //  store.select(getRegSearchState).subscribe(data => this.recs = data);

  //  for (let city of this.recs.city[0].citytowns) {
  //    if (city.isChecked)
  //      this.towns.push(city.townName);
  //  }

  //}

  constructor(private router: Router, private store: Store<AppState>, public nav: NavMenuService) {
    store.select(getRegSearchState).subscribe(data => this.recs = data);

    for (let city of this.recs.city.citytowns[0].citytowns) {
      if (city.isChecked)
        this.towns.push(city.townName);
    }

  }

  back(url) {
    try {
      this.nav.show();
      this.router.navigate([url]);
    }
    catch (error) {
    }

  }


  ngOnInit() {
  }

  ngOnDestroy() {
    this.nav.show();
  }

}
